import type { TransactionChangePayment } from "../../api/specialized.ts";

/** Cents, with -0 folded to 0 so a balanced cart never reads "-0.00" or counts as a charge. */
export function cents(n: number): number {
    return Math.round(n * 100) / 100 || 0;
}

/**
 * The cart against customer money in, for the Edit Transaction summary and its settle button.
 *
 * Rounded to cents. Price + Tax summed in floating point leaves dust — a CAPTURE of 110.34 + 6.66
 * and its refund net to -3.6e-15 — and compared exactly with zero, that dust turned a fully
 * refunded, balanced cart into "Save & Charge 0.00".
 *
 * SUBSIDY payments are not customer money: they are an in-house adjustment already represented by
 * the matching RowType 36/42 package row (negative InitialAmount), which `cart` includes. Counting
 * them as paid would double-count and produce a phantom refund. Matches WebAdmin2's
 * WorkingDataSummary (popupEditCart2.ts:369) and the server's RefundAllocation.RefundDue.
 */
export function settlement(cart: number, payments: TransactionChangePayment[]): { cart: number; paid: number; diff: number } {
    const paid = payments
        .filter(p => p.Type !== "SUBSIDY")
        .reduce((s, p) => s + (p.Price ?? 0) + (p.Tax ?? 0), 0);
    const c = cents(cart);
    const pd = cents(paid);
    return { cart: c, paid: pd, diff: cents(c - pd) };
}
